module.exports = __webpack_public_path__ + "static/img/r-11.bb17803.png";


//////////////////
// WEBPACK FOOTER
// ./src/products/r-11.png
// module id = zUnL
// module chunks = 0